import dayjs from 'dayjs';
import React, { FC } from 'react';

import { ReactComponent as CalendarIcon } from '../../assets/calendar-icon.svg';
import { ReactComponent as ClockIcon } from '../../assets/clock-icon.svg';
import { DataTextBody } from '../data-text-body/data-text-body.component';

type Props = {
  isoDate: string | null | undefined;
  enlarge?: boolean;
  useLighterDataFont?: boolean;
};

export const DateTimeDisplay: FC<Props> = ({ isoDate, enlarge, useLighterDataFont }) => (
  <div className={`flex flex-row justify-start gap-2 md:gap-4 ${enlarge ? 'justify-between' : ''}`}>
    <div className="flex flex-row items-center gap-1 md:gap-2">
      <CalendarIcon />
      <div className='pt-1'>
        <DataTextBody useLightFont={useLighterDataFont}>{isoDate ? dayjs(isoDate).format('DD/MM/YY') : 'Unknown'}</DataTextBody>

      </div>
    </div>
    <div className="flex flex-row items-center gap-1 md:gap-2">
      <ClockIcon />
      <div className='pt-1'>
        <DataTextBody useLightFont={useLighterDataFont}>{isoDate ? dayjs(isoDate).format('HH:mm:ss') : 'Unknown'}</DataTextBody>
      </div>
    </div>
    <div></div>
  </div>
);
